import type { FC } from 'react';
import { Badge } from '@/components/ui/badge';

export const NewBadge: FC = () => {
  return (
    <Badge className="border-transparent bg-orange-500 text-white uppercase">
      new
    </Badge>
  );
};
